<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  <div v-else>
    <!-- Keep-alive should wrap <router-view /> -->

    <div class="homepage d-flex flex-column vh-100">
      <!-- navbar -->
      <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
        <div class="d-flex align-items-center">

          <span @click="goBack()" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span> &nbsp; &nbsp;

          <span>
            <h4 class="text-white">{{language?.new_order}}</h4>
          </span>


          <div class="d-flex align-items-center gap-2 ms-auto">

            <a href="#" class="link-dark text-truncate d-flex align-items-center gap-2" data-bs-toggle="offcanvas"
              data-bs-target="#orderDetailsCanvas" aria-controls="orderDetailsCanvas">
              <b class="bg-white   rounded-circle user-icon">
                <i class="bi bi-cart  d-flex m-1 h4 text-dark"></i>
              </b>
            </a>
          </div>
        </div>




      </div>

      <!-- body -->
      <div class="my-auto overflow-auto vh-100">
        <div class="card-header d-flex justify-content-center p-2">
          <div class="col-12 row">
            <div class="col-10">
                <label>{{language?.select_cutomer}}</label>
                <select class="form-select form-select-sm" id="customers" ref="customers" v-model="order.cust_id">
                  <option value="0" disabled="" selected="">{{language?.select_cutomer}}</option>
                  <option v-for="(item, index) in customers" :key="index" :value="item.id"> {{ item.name }} / {{ item.contact }}</option>
                </select>
                <span class="text-danger">{{duelabel}}</span>
            </div>
            <div class="col-2 pt-3">
                 <a href="#" class="link-dark text-truncate d-flex align-items-center gap-2" data-bs-toggle="offcanvas"
                      data-bs-target="#customer" aria-controls="customer">
                      <b class="bg-primary   rounded-circle user-icon">
                        <i class="bi bi-plus  d-flex m-1 h4 text-white"></i>
                      </b>
                    </a>
            </div>
          </div>

        </div>
        <!-- Top Evets -->
        <div class="container bg_card  pb-5">

          <div class="  pt-2 row">
            <div class="col-12 ">
              <input type="text" v-model="search_txt" :placeholder="language?.search_product" class="form-control">
            </div>
            <router-link v-if="filteredproductsList && filteredproductsList.length==0" to="/products" class="p-3">{{language?.no_product_cost}}</router-link>
            <div class="  border-1 overflow-hidden col-6" v-for="(product,i) in filteredproductsList"
              @click="addcart(product.id)">

              <div class="card card-body ">
                <!-- <b>{{branch.name}}</b> -->
                <div> <strong>{{ product.name }}</strong></div>
                <!--<div>{{cost.description}}</div>-->
                <div>
                  <span class="badge bg-success">
                    <i class="bi bi-cart"></i> &nbsp; Add
                  </span>
                </div>
              </div>




            </div>
         </div>
          </div>
            <div class="footer_area">
                <div class="container row text-dark">
                    <div class="col-6">
                        <b>{{language?.total_amount}} : {{order.total_amt}}    </b>
                    </div>
                    <div class="col-6">
                        <b>{{language?.total_qty}} : {{order.total_qty}}</b>
                    </div>
                
 
                 </div>
             <!--<button class="btn btn-success col-12" v-if="selected_services && selected_services.length>0" @click="confirmCosts">-->
             <span class="btn btn-success col-12"  data-bs-toggle="offcanvas"
              data-bs-target="#orderDetailsCanvas" aria-controls="orderDetailsCanvas">
              <i class="bi bi-check"></i> &nbsp; {{language?.create_order}}
            </span>
        </div>
 







      </div>

      <div class="offcanvas offcanvas-end border-0" tabindex="-1" id="cost" aria-labelledby="costLabel">
        <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
          <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i
              class="bi bi-arrow-left fs-5 text-white"></i></a>
          <h6 class="offcanvas-title text-white m-0" id="costLabel">Select Service</h6>
        </div>
        <div class="offcanvas-body">
          <div class="card border-1 overflow-hidden m-1" v-for="(cost, i) in filteredproductsCostList" :key="cost.id"
            @click="focusInput(cost.id)">
            <div class="card-body row">
              <div class="col-8">
                <strong>{{ cost.service_name }}</strong>
                <div>Rs. {{ cost.cost }}</div>
              </div>
              <div class="col-4">
                <input type="number" :id="'input_' + cost.id" v-model="getService(cost.id).qty" class="form-control"
                  required ref="serviceInputs" placeholder="qty" @input="updateService(cost)" />
              </div>
            </div>
          </div>
  <div class="container row ">
            <div class="col-6">
            <button class="btn btn-success col-12" @click="confirmCosts">
              <i class="bi bi-check"></i> &nbsp; {{language?.confirm_order}}
            </button>
            </div>
            <div class="col-6"> 
             <button class="btn btn-primary w-100 col-6 " @click="serviceBack">{{language?.create_cutomer_back}}</button>
            </div>    
        </div>
          
        </div>
      </div>

<!-- side canvas----------------------------------------------------------------------------------------------------------------------------------->
<div class="offcanvas offcanvas-end border-0" tabindex="-1" id="customer" aria-labelledby="customerLabel">
  <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
     <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left fs-5 text-white"></i></a>
     <h6 class="offcanvas-title text-white m-0" id="branchLabel">{{language?.create_cutomer_heading}}</h6>
  </div>
  <div class="offcanvas-body">
    
         
             <div class="mb-3">
                 <label for="mobile" class="form-label">{{language?.create_cutomer_name}}</label>
                 <input type="text" id="mobile" v-model="customer.name" class="form-control" required>
             </div>
          <div class="mb-3">
           <label for="mobile" class="form-label">{{language?.create_cutomer_cell}}</label>
           <input type="number" id="mobile" v-model="customer.contact" class="form-control" required>
       </div>
          <div class="mb-3">
            <label for="address" class="form-label">{{language?.create_cutomer_address}}</label>
            <input type="text" id="address" v-model="customer.address" class="form-control" required>
        </div>
        <div class="mb-3">
          <label for="address" class="form-label">{{language?.create_opening_balance}}</label>
          <input type="text" id="address" v-model="customer.openingbalance" class="form-control" required>
      </div>
        <div class="container row ">
            <div class="col-6">
             <button class="btn btn-success w-100 col-6" @click="addcustomer">  <i class="bi bi-check"></i> &nbsp; {{language?.create_cutomer_save}}</button>   
            </div>
            <div class="col-6"> 
             <button class="btn btn-primary w-100 col-6 " @click="customerBack"><i class="bi bi-arrow-left"></i> &nbsp;{{language?.create_cutomer_back}}</button>
            </div>    
        </div>
             
          
  </div>
</div>
<!-- side canvas ---------------------------------------------------------------------------------------------------------------------------------->






      <div class="offcanvas offcanvas-bottom custom_height border-0" tabindex="-1" id="orderDetailsCanvas"
        aria-labelledby="orderLabel">
        <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
          <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i
              class="bi bi-arrow-left fs-5 text-white"></i></a>
          <h6 class="offcanvas-title text-white m-0" id="orderLabel">{{language?.create_order_details}}</h6>
        </div>
        <div class="offcanvas-body">
            <div class="col-12 row">
                <div class="col-6">
                    <label for="address m-0 p-0" class="form-label">{{language?.create_order_date}}</label>
                    <input type="date" id="" v-model="order.order_date" class="form-control m-0 p-0" >
                </div>
                <div class="col-6">
                    <label for="address m-0 p-0" class="form-label">{{language?.create_order_delv_date}}</label>
                    <input type="date" id="" v-model="order.delivery_date" class="form-control m-0 p-0" >
                </div>
        </div>
            
            
            <template v-for="(item, i) in selected_services" :key="item.id" >
                          <div class="bottom_border border-1 overflow-hidden m-1 mb-2" v-if="item.qty!=0" >
                          <div class="col-12">
                                <strong>{{ item.productName + ' x ' + item.qty }} </strong>
                                <div>{{ item.serviceName}}</div>
                                <div class="text-danger">Rs. {{parseFloat(item.qty)*parseFloat(item.rate)+'   ('+item.rate+'/per)' }}</div>
                              </div> 
                          </div>
                </template>
          <div class="col-12 row">
            <div class="col-6 ">
                    <label for="address m-0 p-0" class="form-label">{{language?.total_amount}}</label>
                    <input type="number" id="" v-model="order.total_amt" class="form-control m-0  " >
            </div>
            <div class="col-6">
                    <label for="address m-0 p-0" class="form-label">{{language?.paid_amount}}</label>
                    <input type="number" id="" v-model="order.paid_amt" ref="paidAmountInput" class="form-control m-0  " onclick="this.select()"  >
            </div>

            <div class="">
              <label for="remark" class="form-label">{{language?.remark}}</label>
              <textarea id="remark" v-model="order.remark"  rows="2" class="form-control m-0"></textarea>
          </div>
          <div class="mb-1">
            <label  class="form-label" for="img_upload_here">{{language?.Image}}<br>
            <input type="file" id="img_upload_here" style="display: none;" @change="eventFileUpload" class="form-control" required>
            <img src="../assets/upload_image.jpg" style="             height: 50px; "/>
            <img v-if="imagePreview" :src="imagePreview" style="max-width: 150px; border: 2px solid #000; border-radius: 5px;">
            </label>
        </div>
          </div>
        </div>
         <div class="offcanvas-footer">
             <!--<button class="btn btn-success col-12" v-if="selected_services && selected_services.length>0" @click="confirmCosts">-->
             <button class="btn btn-success col-12"  @click="saveOrder">
              <i class="bi bi-check"></i> &nbsp;{{language?.confirm_order}}
            </button>
         </div>
      </div>

    </div>
  </div>
</template>
<style>
.bottom_border{
        border-bottom: 1px solid gray;
}
.footer_area{
        position: fixed;
        width: -webkit-fill-available;
        bottom: 0;
        background: aliceblue;
        padding: 5px 10px;
}
    .custom_height {
           min-height: 80vh;
        max-height: 80vh;
        overflow-y: auto;
    }
</style>
<script>
import axios from "@/plugins/axios";
import { reactive } from "vue";

  export default {
    name: 'Branch',
    components: {
    },
    
    
    mounted() {
      //  this.fetchWeather();
      this.getNewOrderBasics(); // Call the method here
  
    },
    watch: {
      search_txt(newVal) {
        this.filteredproductsList = this.productsList.filter((item) =>
          item.name.toLowerCase().includes(newVal.toLowerCase())
        );
      },
       
    },
    data() {
      return { 
        loading: false,
        error: null,
        isUserLogged: false,
        user_details: [],
        productsList: [],
        productsCostList: [],
        filteredproductsCostList: [],
        filteredproductsList: [],
        selected: [],
        customers: [],
        selected_services: {},
        order_products_services: {},
        order_file: null,
        imagePreview: null,
 
        customer:{
          name:'',
          contact:'',
          address:'',
          openingbalance:'',
        },
        duelabel:'',
        order: {
          cust_id: 0,
          total_amt: 0,
          total_qty: 0,
          order_date: new Date().toISOString().slice(0, 10),
          delivery_date: new Date().toISOString().slice(0, 10),
          remark:'',
          paid_amt:0,
        },
        search_txt: '',
        language:this.getLocalStorageArray('lang'),
        order_file:'',

      }
    },
    methods: {
      initializeHomeContent() {


      },


      eventFileUpload(event) {
                this.order_file = event.target.files[0]; // Store the selected file
                const file = event.target.files[0]; // Correctly define 'file'
                    if (file) {
                      this.order_file = file; // Store the selected file
                      this.imagePreview = URL.createObjectURL(file); // Create image preview
                    }
            },


      goBack() {
          
          this.$router.go(-1);
  },
        getCalculations(){
            const servicesArray = Array.isArray(this.selected_services)
    ? this.selected_services
    : Object.values(this.selected_services);
    
            this.order.total_amt=0;
            this.order.total_qty=0;
            for(let i=0;i<servicesArray.length;i++){
                let row=servicesArray[i];
                this.order.total_amt += (row.rate * row.qty);
                this.order.total_qty += row.qty;  
            }
                
        },
      getService(id) {
        if (!this.selected_services[id]) {
             this.selected_services[id] ={ productName:'',serviceName:'',productId:0,serviceId:0,qty: 0,rate: 0 };
        //   this.$set(this.selected_services, id, { qty: 0 }); 
        }
        return this.selected_services[id];
      },
      updateService(cost) {
        if (this.selected_services[cost.id]) {
            this.selected_services[cost.id].productId =cost.productid;
            this.selected_services[cost.id].serviceId =cost.serviceid; 
            this.selected_services[cost.id].productName =cost.product_name;
            this.selected_services[cost.id].serviceName =cost.service_name; 
            this.selected_services[cost.id].rate =cost.cost; 
            this.getCalculations();
        }
      },
      focusInput(costId) {
        this.$nextTick(() => {
          const inputElement = this.$refs.serviceInputs.find(
            (input) => input.id === `input_${costId}`
          );
          if (inputElement) {
            inputElement.focus(); 
             inputElement.select(); 
          }
        });
      },
      confirmCosts() {
        window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("cost")).hide();
        console.log("Selected Services:", this.selected_services);
      },
      async getNewOrderBasics() {
        this.loading = true;
        this.error = null;

        try {
          var self = this;
          axios.post("getNewOrderBasics").then((response) => {
            self.productsCostList = response.data.cost;
            self.servicesList = response.data.servicesLists;
            self.productsList = response.data.productsLists;
            self.filteredproductsList = self.productsList;
            self.customers=response.data.customer;
            
            
                     self.language=response.data.language;
                     localStorage.setItem('lang',response.data.language);

          }).then(() => {
            self.initializeHomeContent();

            $(self.$refs.customers).select2({
              width: '100%',
              placeholder: "Search Services Here...",
              "language": {
                "noResults": function () {
                  return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                }
              },
              escapeMarkup: function (markup) {
                return markup;
              }
            }).on('change', function (event) {
                self.order.cust_id= $(this).val(); 
                let cust_row= self.customers.filter((item) =>item.id == self.order.cust_id);
              
                self.duelabel=cust_row[0].dueAmt;
                if(self.duelabel>0)
                    self.duelabel='Balance : '+self.duelabel;
            });

              // Set default value
            


          }).catch((err) => {

          });;


        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      },


      addcart(product_id) {
        this.filteredproductsCostList = this.productsCostList.filter((item) =>
          item.productid == product_id
        );
         console.log("Selected Services:", this.filteredproductsCostList);
        window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("cost")).show();
        // this.cost=editcost;
      },


      addcustomer() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("addcustomer",self.customer).then((response) => {
              
                     self.customers=response.data.customer;
                     self.customer_id=response.data.customer_id;
                     self.$swal.fire(response.data.message);
                     if(response.data.success)
                     {
                        self.customer={ name:'',contact:'',};
                     }
                    
                     window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("customer")).hide();
                     if (self.customer_id) {
                         
                      self.order.cust_id=self.customer_id;
                    //   $('#customers').select2("val", self.customer_id); 
                    //   $("#customers").trigger("change");
                       
                    }

               
        
          }).then(() => {
               self.initializeHomeContent();
                $(self.$refs.customers).val(self.order.cust_id).trigger("change");
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 
      
     customerBack(){
          window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("customer")).hide();
     } ,
       serviceBack(){
          window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("cost")).hide();
     } ,
 async saveOrder() {
        this.loading = true;
        this.error = null;
      
        try {
           var self=this;
           if(self.order.total_amt==0){
              self.$swal.fire("Please Select Product And Service");
              return;
           }else  if(self.order.cust_id==0){
              self.$swal.fire("Please Select Customer");
              return;
           }else{
//  alert("Done");
          axios.post("saveorder",{order:self.order,file:self.order_file,selected_services:self.selected_services},{
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }).then((response) => {
                      
                            self.customers=response.data.customer
                            self.$swal.fire(response.data.message);
                            this.$router.push('/orderDetails?id='+response.data.orderid); 
                            if(response.data.success)
                            {
                                
                                self.customer={ name:'',contact:'',};
                            }
                            window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("customer")).hide();
                              

                      
                
                  }).then(() => {
                      self.initializeHomeContent();
                  }).catch((err) => {
                    
                  });;
                }         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 
      
      
      getLocalStorageArray(key) {
        let data = localStorage?.getItem(key);
        try {
            return data ? JSON.parse(data) : [];
        } catch (e) {
            console.error("Error parsing localStorage data", e);
            return [];
        }
    }

    }
  }






</script>